import { Observable } from 'rxjs';
import { IExecutiveDto } from '../../../models/executive.dto';

export abstract class ExecutivesContract {
  abstract get(): Observable<IExecutiveDto[]>;
  abstract getExecutive(executivesId: number): Observable<IExecutiveDto>;
}
